export function swipersInit() {

  const swiperBanners = new Swiper('.swiper-banners', {
    observer: true,
    observeParents: true,
    observeSlideChildren: true,
    watchOverflow: true,
    speed: 700,
    autoplay: {
      delay: 5000,
      disableOnInteraction: false,
    },
    pagination: {
      el: '.swiper-pagination.banners',
      clickable: true,
    },
  });
}
